module.exports = __webpack_public_path__ + "static/a1000-984a35059d4ae3d7943ea8113b25842f.png";